import { useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { seededShuffleArray, daySeed } from "../utils/arrayUtils";
import "../styles/Masjid.css";


function Masjid({ v2Masjids = [] }) {
  const navigate = useNavigate();
  const containerRef = useRef(null);

  const getSlug = (m) => m.slug || m.profail?.slug || "";
  const shuffledMasjids = useMemo(() => {
    // stable untuk sehari (tak lompat setiap render)
    return seededShuffleArray(v2Masjids, daySeed());
  }, [v2Masjids]);

  const openMosque = (mosque) => {
    const slug = getSlug(mosque);
    if (!slug) return;
    navigate(`/${slug}`, { state: { from: "home" } });
  };

  // drag-scroll (desktop)
  const handleMouseDown = (e) => {
    // hanya left click
    if (e.button !== 0) return;

    e.preventDefault();
    const el = containerRef.current;
    if (!el) return;

    const startX = e.pageX;
    const startScrollLeft = el.scrollLeft;

    const onMove = (ev) => {
      el.scrollLeft = startScrollLeft - (ev.pageX - startX);
    };

    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  // icon button kanan (public/assets)
  const masjidIcon = `${process.env.PUBLIC_URL}/assets/masjid.png`;
  const masjidIconHover = `${process.env.PUBLIC_URL}/assets/masjid-hover.png`;

  const openMasjidPage = () => {
    navigate("/masjid");
  };

  return (
    <div>
      <hr className="hairline" />

      <div className="mosque-strip-wrap">
        <div
          className="mosque-container mosque-container--withEndBtn"
          ref={containerRef}
          onMouseDown={handleMouseDown}
        >
          {shuffledMasjids.map((mosque, index) => {
            const slug = getSlug(mosque);
            const clickable = Boolean(slug);

            return (
              <div
                key={mosque.id || slug || index}
                className={`mosque-card ${clickable ? "clickable" : "disabled"}`}
                onClick={clickable ? () => openMosque(mosque) : undefined}
                onKeyDown={clickable ? (event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openMosque(mosque);
                  }
                } : undefined}
                role={clickable ? "button" : undefined}
                tabIndex={clickable ? 0 : -1}
                title={clickable ? "Buka halaman masjid" : "Belum ada halaman"}
              >
                <img
                  src={mosque.photo_src || mosque.profail?.logo}
                  alt={mosque.name || mosque.profail?.nama}
                  className="mosque-image"
                  onError={(e) => (e.currentTarget.style.display = "none")}
                />
                <div className="mosque-name">{mosque.name || mosque.profail?.nama}</div>
              </div>
            );
          })}
        </div>

        <button
          className="kitab-strip-endbtn mosque-endbtn"
          type="button"
          onClick={openMasjidPage}
          style={{ backgroundImage: `url(${masjidIcon})` }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundImage = `url(${masjidIconHover})`)}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundImage = `url(${masjidIcon})`)}
          aria-label="Buka senarai masjid"
          title="Buka senarai masjid"
        />
      </div>

      <hr className="hairline" />
    </div>
  );
}

export default Masjid;
